import { useAppContext } from "../pages/context/AppContext.jsx";

export function usePermissoes() {
  const { perfil } = useAppContext();

  function getItem(caminho) {
    return perfil?.find(p => p.caminho === caminho);
  }

  return {
    podeAcessar: (caminho) => getItem(caminho)?.permissao_ver === "S",
    podeInserir: (caminho) => getItem(caminho)?.permissao_inserir === "S",
    podeEditar: (caminho) => getItem(caminho)?.permissao_editar === "S",
    podeExcluir: (caminho) => getItem(caminho)?.permissao_excluir === "S",
    podeImprimir: (caminho) => getItem(caminho)?.permissao_imprimir === "S",
  };
}
